export default "__VITE_ASSET__86ecc30c__"